const config = {
  WEBSITE_DOMAIN:
    process.env.NEXT_PUBLIC_WEBSITE_URL ??
    process.env.NEXT_PUBLIC_VERCEL_URL ??
    "localhost",
};

export default config;
